import { Button, Dropdown, Input, InputRef, message, Segmented, Select, Space, Table, TableProps, Tag, Tooltip, Upload } from "antd";
import DeleteModalSimple from "./DeleteModalSimple"
import { useEffect, useMemo, useRef, useState } from "react";
import SortIcon from "../../../components/icons/SortIcon";
import { BRAND_ASSETS, PRODUCT_ASSETS, STATUS_CANCELLED, STATUS_COMPLETED, STATUS_PENDING, STATUS_REQUESTED, STATUS_UPLOADED, TAB_ASSETS } from "../../../constants/constants";
import FilterIcon from "../../../components/icons/FilterIcon";
import ThreeDotsIcon from "../../../components/icons/ThreeDotsIcon";
import { assetTypes } from "../../../constants/dataConstants";
import FileIcon from "../../../components/icons/FileIcon";
import FileIconSmall from "../../../components/icons/FileIconSmall";
import EyeIcon from "../../../components/icons/EyeIcon";
import DownloadIcon from "../../../components/icons/DownloadIcon";
import InfoIcon from "../../../components/icons/InfoIcon";
import DownArrowIcon from "../../../components/icons/DownArrowIcon";
import AssetInfoModal from "./modals/AssetInfoModal";
import AddEditProductAssetModal from "./modals/AddEditProductAssetModal";
import UploadProductAssetModal from "./modals/UploadProductAssetModal";
import { deleteProductDoc, getProductAssets, getProductAssetsRequests, updateRequestForProductDoc, uploadProductDoc } from "../../../API/endpoints/Products";
import { deleteBrandDoc, getAllBrandProducts, getBrandAssets, getBrandAssetsRequests, updateRequestForBrandDoc, uploadBrandDoc, uploadBrandMandatoryFile } from "../../../API/endpoints/Brands";
import SearchIconSmall from "../../../components/icons/SearchIconSmall";
import { FilterDropdownProps } from "antd/es/table/interface";
import PdfViewerModal from "../../components/Modal/PdfViewerModal";
import { useBrandTabsContext } from "../contexts/BrandTabsContext";
import dayjs from "dayjs";

interface Props {
    brand: any;
    reload?: boolean;
    isBrandUser?: boolean
}
const Assets = (props: Props) => {
    const { brand, isBrandUser } = props;

    const [messageApi, contextHolder] = message.useMessage();
    const { productID, setProductID, activeTab, reloadProducts, setReloadProducts } = useBrandTabsContext();

    const [isDeleteItem, setIsDeleteItem] = useState<any>({});
    const [isAddAsset, setIsAddAsset] = useState(false);
    const [isEditAsset, setIsEditAsset] = useState<any>({});
    const [isUploadAsset, setIsUploadAsset] = useState(false);
    const [isEditUploadAsset, setIsEditUploadAsset] = useState<any>({});

    const [pageNumber, setPageNumber] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(false);

    const [activeAsset, setActiveAsset] = useState(productID ? PRODUCT_ASSETS : BRAND_ASSETS)
    const [infoData, setInfoData] = useState<any>({})

    const [data, setData] = useState<any[]>([]);
    const [dataFiltered, setDataFiltered] = useState<any[]>([]);
    const [productsList, setProductsList] = useState<any[]>([]);

    const searchInput = useRef<InputRef>(null);
    const [searchKey, setSearchKey] = useState("");
    const [selectedStatuses, setSelectedStatuses] = useState<string[]>([])
    const [sortOrder, setSortOrder] = useState<"ascend" | "descend" | null>(null);

    const [pdfData, setPdfData] = useState<any>({});

    const tableRef = useRef<any>(null);
    const [scrollY, setScrollY] = useState(0);


    useEffect(() => {
        setData([]);
        setTotalCount(0);
        setLoading(true);

        if (activeAsset === PRODUCT_ASSETS) {
            if (productID) {
                getProductAssetsRequests(productID)
                    .then((response) => {
                        const docs = response?.data?.documents?.rows || [];
                        const reqs = response?.data?.requests?.rows || [];
                        const mandReqs = response?.data?.mandatoryDocs || [];

                        const combined = [...docs, ...reqs].sort(
                            (a, b) => dayjs(b.created_at).valueOf() - dayjs(a.created_at).valueOf()
                        );

                        setData([...mandReqs, ...combined]);
                        setTotalCount(response?.data?.documents?.count + response?.data?.requests?.count);
                        setLoading(false);
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error);
                    });
            } else {
                setLoading(false);
            }

        } else {
            if (props?.brand?.id) {
                getBrandAssetsRequests(props?.brand?.id)
                    .then((response) => {
                        const docs = response?.data?.documents?.rows || [];
                        const reqs = response?.data?.requests?.rows || [];
                        const mandReqs = response?.data?.mandatoryDocs || [];

                        const combined = [...docs, ...reqs].sort(
                            (a, b) => dayjs(b.created_at).valueOf() - dayjs(a.created_at).valueOf()
                        );

                        setData([...mandReqs, ...combined]);
                        setTotalCount(response?.data?.documents?.count + response?.data?.requests?.count);
                        setLoading(false);
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error);
                    });
            } else {
                setLoading(false);
            }

        }

    }, [props?.brand, props?.reload, pageNumber, reload, activeAsset, productID])

    useEffect(() => {
        setDataFiltered(() => {
            // Step 1: Filter
            const filtered = data?.filter((item: any) => {
                const matchesSearch = item?.file_name?.toLowerCase().includes(searchKey?.toLowerCase());
                const matchesStatus = selectedStatuses?.length
                    ? selectedStatuses.includes(item?.status) ||
                    ((item?.path || item?.status === STATUS_UPLOADED) &&
                        selectedStatuses.includes(STATUS_COMPLETED))
                    : true;
                return matchesSearch && matchesStatus;
            }) ?? [];

            // Step 2: Sort
            const sorted = [...filtered].sort((a, b) => {
                const nameA = a?.file_name?.toLowerCase() ?? '';
                const nameB = b?.file_name?.toLowerCase() ?? '';

                if (sortOrder === 'ascend') {
                    return nameA.localeCompare(nameB);
                } else if (sortOrder === 'descend') {
                    return nameB.localeCompare(nameA);
                }
                return 0;
            });

            return sorted;
        });
    }, [data, searchKey, selectedStatuses, sortOrder]);


    useEffect(() => {
        if (productID) {
            setActiveAsset(PRODUCT_ASSETS)
        }
    }, [productID])

    useEffect(() => {
        getAllBrandProducts(brand.id).then((res: any) => {
            setProductsList(res?.data?.rows || [])
            if (!productID && activeTab === TAB_ASSETS && activeAsset === PRODUCT_ASSETS) {
                setProductID(res?.data?.rows?.[0]?.id || "")
            }

        }).catch((err) => {
            console.log("err", err);

        })
    }, [brand, activeAsset, activeTab])


    useEffect(() => {
        const updateScrollY = () => {
            if (tableRef.current) {
                const containerHeight = tableRef.current.clientHeight;
                const headerHeight = 48; // Adjust this value if your header is bigger/smaller
                setScrollY(containerHeight - headerHeight);
            }
        };

        updateScrollY();
        window.addEventListener('resize', updateScrollY);
        return () => window.removeEventListener('resize', updateScrollY);
    }, []);

    const onSuccessAddAsset = (data: any) => {
        setReload(!reload)
        messageApi.success(isEditAsset?.name ? "Request updated successfully" : "Request added successfully");
        if (!isEditAsset?.name) {
            setReloadProducts(!reloadProducts)
        }
        setIsEditAsset({});
        setIsAddAsset(false);

    }

    const onCancelAddAsset = () => {
        setIsEditAsset({});
        setIsAddAsset(false);
    }


    const onSuccessUploadAsset = (data: any) => {
        setReload(!reload)
        messageApi.success(isEditAsset?.name ? "Asset updated successfully" : "Asset uploaded successfully");
        setIsEditUploadAsset({});
        setIsUploadAsset(false);
    }

    const onCancelUploadAsset = () => {
        setIsEditUploadAsset({});
        setIsUploadAsset(false);
    }

    const onSuccessDeleteAsset = () => {
        messageApi.success("Asset deleted successfully");
        const newList = data.filter((item: any) => item?.id !== isDeleteItem?.id)
        setData([...newList])
        setIsDeleteItem({});
    }

    const onRequestCancellation = () => {
        if (activeAsset === PRODUCT_ASSETS) {
            updateRequestForProductDoc(isDeleteItem?.id, { status: STATUS_CANCELLED }).then((res: any) => {
                setReload(!reload)
                messageApi.success("Request cancelled successfully");
                setIsDeleteItem({})
            }).catch((err) => {
                console.log('err', err);

            });
        } else {
            updateRequestForBrandDoc(isDeleteItem?.id, { status: STATUS_CANCELLED }).then((res: any) => {
                setReload(!reload);
                messageApi.success("Request cancelled successfully");
                setIsDeleteItem({})
            }).catch((err) => {
                console.log('err', err);

            });
        }

    }


    const statusFilters = [
        {
            text: 'Pending',
            value: STATUS_REQUESTED,
        },
        {
            text: 'Completed',
            value: STATUS_COMPLETED,
        },
        {
            text: 'Cancelled',
            value: STATUS_CANCELLED,
        },
    ];

    const onFilter = (filters: any, sortOrder: any) => {
        setSelectedStatuses(filters?.status || []);
        console.log('sortOrder', sortOrder);

        setSortOrder(sortOrder?.order || null);
    }

    const addButtons = useMemo(() => {
        let items: any = [];
        items.push(
            {
                key: '1',
                label: "Asset Upload",
                onClick: () => {
                    setIsUploadAsset(true);
                }
            }
        )

        items.push({
            key: '2',
            label: "Asset Request",
            onClick: () => {
                setIsAddAsset(true);
            }
        })

        return items;
    }, [])


    const actionOptions = (record: any) => {
        let items: any = [];
        items.push(
            {
                key: '1',
                label: "Edit",
                onClick: () => {
                    if (record?.status === STATUS_REQUESTED) {
                        setIsEditAsset(record)
                        setIsAddAsset(true)
                    } else {
                        setIsEditUploadAsset(record)
                        setIsUploadAsset(true)
                    }

                }
            }
        )

        items.push({
            key: '2',
            danger: true,
            label: record?.status === STATUS_REQUESTED ? "Cancel request" : "Delete",
            onClick: () => setIsDeleteItem(record)
        })

        return items;
    }


    // ================================================================================================
    const handleSearch = (selectedKeys: any, confirm: any) => {
        confirm();
        if (selectedKeys[0] != undefined) {
            setSearchKey(selectedKeys[0]?.trim());
        }
    };

    const handleReset = (clearFilters: any) => {
        clearFilters();
        setSearchKey("");
    };


    const handleUploadFile = (data: any, file: any) => {
        if (!file) return;

        const maxFileSize = 10 * 1024 * 1024;
        if (file.size > maxFileSize) {
            messageApi.error("File size exceeds 10MB. Please upload a smaller file.");
            return;
        }

        const req = new FormData();
        const isProductAsset = activeAsset === PRODUCT_ASSETS;

        if (data?.field_name) {
            const req = new FormData();
            req.append("file", file);
            req.append("brand_id", data?.brand_id);
            req.append("field", data?.field_name);

            uploadBrandMandatoryFile(req)
                .then(() => {
                    setReload(!reload);
                    messageApi.success("Report uploaded successfully");
                })
                .catch((err) => {
                    console.error('Upload error:', err);
                    messageApi.error("Failed to upload doc. please try again!");
                });

        } else if (isProductAsset) {
            req.append("product_id", data?.product_id);
            req.append("file", file);
            req.append("file_name", data?.file_name);
            req.append("file_type", "Product Assets");
            req.append("service", "1");
            req.append("description", data?.description);

            uploadProductDoc(req)
                .then(() => {
                    onSuccessUploadAsset(data);
                })
                .catch((err) => {
                    console.error('Upload error:', err);
                    messageApi.error("Failed to upload doc. please try again!");
                });

        } else {
            req.append("brand_id", data?.brand_id);
            req.append("file", file);
            req.append("file_name", data?.file_name);
            req.append("file_type", "Brand Assets");
            req.append("service", "1");
            req.append("description", data?.description);

            uploadBrandDoc(req)
                .then(() => {
                    onSuccessUploadAsset(data);
                })
                .catch((err) => {
                    console.error('Upload error:', err);
                    messageApi.error("Failed to upload doc. please try again!");
                });
        }
    };


    const downloadFile = (path: string) => {
        window.open(path, "_blank");
    };

    const getColumnSearchProps = (dataIndex: any) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }: FilterDropdownProps) => (
            <div style={{ padding: 8 }}>
                <Input
                    classNames={{
                        input: "text-[12px]"
                    }}
                    ref={searchInput}
                    placeholder={`Search`}
                    value={selectedKeys[0]}
                    prefix={<SearchIconSmall />}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm)}
                    className="mb-[8px]"
                />
                <div className="flex gap-2 justify-end">
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        className="text-[12px]"
                    >Reset</Button>
                    <Button
                        type="primary"
                        title="Search"
                        size="small"
                        className="text-[12px]"
                        onClick={() => handleSearch(selectedKeys as string[], confirm)}
                    >Search</Button>
                </div>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchIconSmall color={searchKey ? "#0152FB" : "#667085"} />
        ),
    });


    const columns: TableProps['columns'] = [
        {
            title: "Document / File Name",
            dataIndex: 'file_name',
            key: 'file_name',
            width: "25%",
            sorter: true,
            sortIcon: ({ sortOrder }) => <SortIcon order={sortOrder} />,
            render: (text) => (
                <div className="flex gap-x-[10px] items-center">
                    <FileIcon />
                    <p className="m-0 text-[12px] font-[500] flex-1">{text}</p>
                </div>

            ),
            ...getColumnSearchProps("file_name")
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            width: "10%",
            render: (text) => (
                <Tooltip title={text}>
                    <p className="m-0 w-[220px] truncate">{text}</p>
                </Tooltip>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: "10%",
            filters: statusFilters,
            filterIcon: (filtered: boolean) => (
                <FilterIcon filtered={filtered} />
            ),
            render: (text, record: any) => (
                text && text !== STATUS_UPLOADED ? (
                    <Tag bordered={false} color={text === STATUS_REQUESTED ? "warning" : "error"} className="rounded-[16px] capitalize">{text === STATUS_REQUESTED ? "Pending" : text?.toLowerCase()}</Tag>
                ) : (
                    record?.path || text === STATUS_UPLOADED ? (
                        <Tag bordered={false} color="success" className="rounded-[16px]">Completed</Tag>
                    ) : (
                        <></>
                    )

                )
            ),
        },
        {
            title: 'Files',
            dataIndex: 'path',
            key: 'path',
            width: "20%",
            render: (path, record: any) => (
                path ? (
                    <Space>
                        <FileIconSmall />
                        <Tooltip title={record?.file_name}>
                            <p className="m-0 w-[154px] truncate text-[12px] leading-[12px]">{record?.file_name}</p>
                        </Tooltip>
                        <Button type="text" size="small" icon={<EyeIcon />} className="bg-[#EDEDED]" onClick={() => setPdfData({ path: path, name: record?.file_name })} />
                        <Button type="text" size="small" icon={<DownloadIcon />} className="bg-[#EDEDED]" onClick={() => downloadFile(path)} />
                    </Space>
                ) : (
                    <></>
                )

            )
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            width: "20%",
            align: "end",
            render: (_, record: any) => (
                <Space>
                    {record?.path || record?.status === STATUS_CANCELLED ? (
                        <></>
                    ) : (
                        <Upload
                            className="w-full upload-form-item"
                            onChange={(e: any) => handleUploadFile(record, e?.file,)}
                            beforeUpload={(file) => {
                                return false
                            }}
                            showUploadList={false}
                        >
                            <Button type="primary" size="small" className="text-[12px] leading-[12px]" onClick={(e) => e.preventDefault()}>Upload</Button>
                        </Upload>
                    )}
                    {record?.status === STATUS_CANCELLED || isBrandUser ? (
                        <></>
                    ) : (
                        <Dropdown menu={{ items: actionOptions(record) }}>
                            <Button icon={<ThreeDotsIcon />} type="text" className="leading-[12px]" onClick={(e) => e.preventDefault()} />
                        </Dropdown>
                    )}

                    <Button icon={<InfoIcon />} type="text" className="leading-[12px]" onClick={(e) => setInfoData(record)} />
                </Space>

            )
        },
    ]



    return (
        <div className="h-[calc(100vh-256px)] bg-white p-[20px] rounded-[8px] w-full">
            {contextHolder}
            <div className="flex justify-between mb-[16px] stick">
                <Segmented
                    options={assetTypes}
                    value={activeAsset}
                    onChange={(value) => {
                        setActiveAsset(value)
                    }}
                />
                <Space>
                    {activeAsset === PRODUCT_ASSETS ? (
                        <Select
                            className="w-[190px]"
                            options={productsList}
                            fieldNames={{ label: "name", value: "id" }}
                            rootClassName="rounded-input"
                            onChange={(value: string) => {
                                setProductID(value);
                            }}
                            value={productID}
                        />
                    ) : (
                        <></>
                    )}

                    {!isBrandUser ? (
                        <Dropdown menu={{ items: addButtons }}>
                            <Button icon={<DownArrowIcon />} type="primary" onClick={(e) => e.preventDefault()} iconPosition="end">New</Button>
                        </Dropdown>
                    ) : (
                        <Button type="primary" onClick={(e) => setIsUploadAsset(true)} >Upload Asset</Button>
                    )}

                </Space>

            </div>
            <div
                ref={tableRef}
                className='h-[calc(100%-32px)] overflow-hidden w-full'
            >
                <Table
                    size="small"
                    rowKey={"id"}
                    columns={columns}
                    dataSource={dataFiltered}
                    loading={loading}
                    pagination={false}
                    onChange={(_: any, filters: any, sortOrder: any) => onFilter(filters, sortOrder)}
                    scroll={{ y: scrollY, x: 'max-content' }}

                />
            </div>
            <AssetInfoModal
                title={activeAsset?.replaceAll("_", " ")?.toLowerCase()}
                data={infoData}
                onClose={() => setInfoData({})}
            />
            <AddEditProductAssetModal
                brand={props?.brand}
                isProduct={activeAsset === PRODUCT_ASSETS}
                open={isAddAsset}
                products={productsList}
                editData={isEditAsset}
                onCancel={() => onCancelAddAsset()}
                onSuccess={(data: any) => onSuccessAddAsset(data)}
            />
            <UploadProductAssetModal
                title={activeAsset === PRODUCT_ASSETS ? "Product Assets" : "Brand Assets"}
                brand={props?.brand}
                isProduct={activeAsset === PRODUCT_ASSETS}
                open={isUploadAsset}
                products={productsList}
                editData={isEditUploadAsset}
                onCancel={() => onCancelUploadAsset()}
                onSuccess={(data: any) => onSuccessUploadAsset(data)}
            />
            <DeleteModalSimple
                title={isDeleteItem?.status === STATUS_REQUESTED ? "Asset Request" : "Asset"}
                content={isDeleteItem?.status === STATUS_REQUESTED ? "Are you sure you want to cancel this asset request?" : "Are you sure you want to delete this asset ?"}
                okText={isDeleteItem?.status === STATUS_REQUESTED ? "Yes, Cancel" : "Yes, Delete"}
                item={isDeleteItem}
                onCancel={() => setIsDeleteItem({})}
                onSuccess={() => onSuccessDeleteAsset()}
                onOk={() => isDeleteItem?.status === STATUS_REQUESTED ? onRequestCancellation() : null}
                api={activeAsset == PRODUCT_ASSETS ? deleteProductDoc : deleteBrandDoc}
            />
            <PdfViewerModal
                pdfData={pdfData}
                isPdfOpen={Object.keys(pdfData).length > 0}
                closeModal={() => setPdfData({})}
            />
        </div>
    )
}

export default Assets